(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eleventh-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function toggleFaq(element) {
    const faqItem = element.parentElement;
    const faqAnswer = faqItem.querySelector('.faq-answer');
    const isActive = faqItem.classList.contains('active');
    
    // Chiudi tutte le altre FAQ
    document.querySelectorAll('.faq-item.active').forEach(item => {
      if (item !== faqItem) {
        item.classList.remove('active');
        item.querySelector('.faq-answer').classList.remove('active');
      }
    });
    
    // Toggle della FAQ corrente
    if (isActive) {
      faqItem.classList.remove('active');
      faqAnswer.classList.remove('active');
    } else {
      faqItem.classList.add('active');
      faqAnswer.classList.add('active');
    }
  }
  
  // Aggiungi event listeners a tutte le domande FAQ
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', function() {
      toggleFaq(this);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// Scroll to top function for Home
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const hamburgerBtn = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const body = document.body;
  
  if (hamburgerBtn && mobileMenu) {
    hamburgerBtn.addEventListener('click', function() {
      console.log('Hamburger clicked'); // Debug
      hamburgerBtn.classList.toggle('active');
      mobileMenu.classList.toggle('active');
      
      // Prevent body scroll when menu is open
      if (mobileMenu.classList.contains('active')) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = '';
      }
    });
    
    // Close menu when clicking on a link
    const mobileMenuLinks = mobileMenu.querySelectorAll('a');
    mobileMenuLinks.forEach(link => {
      link.addEventListener('click', function() {
        hamburgerBtn.classList.remove('active');
        mobileMenu.classList.remove('active');
        body.style.overflow = '';
      });
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(event) {
      const hamburgerMenu = document.querySelector('.hamburger-menu');
      
      if (hamburgerMenu && !hamburgerMenu.contains(event.target) && mobileMenu.classList.contains('active')) {
        hamburgerBtn.classList.remove('active');
        mobileMenu.classList.remove('active');
        body.style.overflow = '';
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-summer-racing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var popup = document.querySelector('.promo-popup');
    if (!popup) return; // dopo la fine promo la sezione non renderizza nulla: niente da fare

    var closeBtn = popup.querySelector('.promo-popup__close');
    var key = popup.getAttribute('data-key') || 'promo_seen';
    var once = popup.getAttribute('data-once') === '1';
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      popup.classList.add('is-open');
      document.documentElement.classList.add('promo-no-scroll');
      if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
    }
    function close() {
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('promo-no-scroll');
      if (once) { try { sessionStorage.setItem(key, '1'); } catch (e) {} }
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && popup.classList.contains('is-open')) close();
    });

    var inEditor = window.Shopify && window.Shopify.designMode;
    var seen = false;
    if (once && !inEditor) { try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {} }

    if (!seen) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', open);
      } else {
        open();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
